export const DELEGATES_ROOT = 'v1/delegates';
export const DELEGATES = 'delegates';
